module.exports = __webpack_public_path__ + "images/mbway.c49fac668c44eec24f61888c27200558.svg";